<template>
<div class="inpBox">
   <div class="detailsTitle">
      <h4>详情</h4>
      <div @click="back"><i class="fa fa-reply"></i></div>
  </div>
   <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform"   class="demo-form-inline" label-width="110px" size="mini">
      <div class="addressBox" >
        <h4 class="title">
          <span><i class="fa fa-envelope iconFont" aria-hidden="true"></i>收发货信息</span>
        </h4>
        <div class="box1" >
            <div class="item">
               <div>
                <div class="box1T" style="color:#0c46a2"><i class="el-icon-location"></i>发货信息</div>
                <div class="box1B"><span>{{goodform.deliverPerson}}</span><span>{{goodform.deliverPhone}}</span><span>{{goodform.deliverAddress}}</span></div>
              </div>

            </div>
             <div class="item1">
              <div class="box1T" style="color:#F56C6C" > <i class="el-icon-location"></i>收货信息</div>
              <div class="box1B"><span>{{goodform.receivingPerson}}</span><span>{{goodform.receivingPhone}}</span><span>{{goodform.receivingAddress}}</span></div>
            </div>
        </div>
      </div>
      <hr>
      <div class="addressBox">
         <h4 class="title">
          <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>货物信息</span>
        </h4>
        <div>
       <el-table :data="goodList"  ref="table"  border  bordersize="mini" style="width: 100%" center>
        <el-table-column  type="index" prop="date" width="55" label="序号"></el-table-column>
          <el-table-column property="productTypeName" min-width="200" label="货物类型"></el-table-column>
          <el-table-column property="productionPlace" width="170"  label="产地"></el-table-column>
          <el-table-column property="specification" min-width="140"  label="规格"></el-table-column>
          <el-table-column property="model" width="120" label="材质"></el-table-column>
          <el-table-column property="number" width="140"  label="件数"></el-table-column>
          <el-table-column property="weight" width="100" label="重量(吨)"></el-table-column>
          <el-table-column property="cargoBarcode" min-width="150" label="捆包号"></el-table-column>
          </el-table>
        </div>
      </div>
      <hr>
      <div class="addressBox">
          <h4 class="title">
            <span v-if="goodform.demandType==1"><i class="fa fa-bars iconFont" aria-hidden="true"></i>竞价信息</span>
          </h4>
          <h4 class="title">
            <span v-if="goodform.demandType==2"><i class="fa fa-bars iconFont" aria-hidden="true"></i>抢单信息</span>
          </h4>
          <div>
            <div v-if="goodform.demandType==1">
              <div>
              <el-form-item label="报价方式:" >
                <span>{{goodform.pricingMethod==1?'单价':'包干'}}</span>
              </el-form-item>
              <el-form-item label="限价区间(不含税):" label-width="297px" v-if="goodform.pricingMethod==1">
                <span>{{goodform.lowPrice}} 元/吨 - {{goodform.highPrice}} 元/吨</span>
              </el-form-item>
              <el-form-item label="限价区间(不含税):" label-width="297px" v-if="goodform.pricingMethod==2">
                <span>{{goodform.lowPrice}} 元 - {{goodform.highPrice}} 元</span>
              </el-form-item>
              <el-form-item label="杂费:" label-width="189px"  >
                <span>{{goodform.incidental?goodform.incidental:0}} 元</span>
              </el-form-item>
              <el-form-item label="合计:"  v-if="goodform.pricingMethod==1" label-width="180px">
                <el-button type="text" @click="totalFN" ><span style="font-size:14px">{{addUp1|numFormat(2)}} 元 ~ {{addUp2|numFormat(2)}} 元</span></el-button>
              </el-form-item>
              <el-form-item label="合计:" v-if="goodform.pricingMethod==2" label-width="180px">
                <el-button type="text" @click="totalFN" ><span style="font-size:14px">{{BGaddUp1|numFormat(2)}} 元 ~ {{BGaddUp2|numFormat(2)}} 元</span></el-button>
              </el-form-item>
              </div>
              <el-form-item  label="发布范围:" prop="publishScopeType" class="ziti" >
                  <span v-if="goodform.publishScopeType==1">长协承运商</span>
                  <span v-if="goodform.publishScopeType==2">指定承运商</span>
              </el-form-item>
              <div style="margin-left:110px;margin-bottom:20px" v-if="goodform.publishScopeType==2">
                <el-tag
                  v-for="(tag,index) in offerList"
                  :key="index">
                  {{tag}}
              </el-tag>
              </div>
              <div>
                <el-form-item label="竞价有效期至:" prop="demandFinalDate">
                  <el-date-picker
                    v-model="goodform.demandFinalDate"
                    format="yyyy-MM-dd HH:mm"
                    value-format="timestamp"
                    type="datetime"
                    :readonly="true"
                      placeholder=""
                  ></el-date-picker>
              </el-form-item>
              </div>
            <div v-if="goodform.triggerStatus == 2 || goodform.triggerStatus == 3">
            <el-form-item label="发布时间点:" prop="triggerStartDate">
                <!-- <el-time-picker
                  v-model="goodform.triggerStartDate"
                  format="HH"
                  value-format="timestamp"
                  :readonly="true"
                  placeholder=""
                ></el-time-picker> -->
                 <span>{{dateFormatUtil('hh:ii', goodform.triggerStartDate)}} </span>
            </el-form-item>
            <el-form-item label="报价有效时长:" prop="triggerDuration" class="jiage" label-width="293px">
               <span>{{goodform.triggerDuration/60}} 小时</span>
            </el-form-item>
            <el-form-item label="循环结束日期:" prop="triggerEndDate" class="inpBox2" label-width="270px">
                <el-date-picker
                  v-model="goodform.triggerEndDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                   :readonly="true"
                  placeholder=""
                ></el-date-picker>
            </el-form-item>
          </div>
            </div>
            <div  v-if="goodform.demandType==2">
              <el-form-item label="计价方式:"   >
                <span style="display:inline-block;width:300px">{{goodform.pricingMethod==1?'单价':'包干'}}</span>
              </el-form-item>
               <el-form-item label="单价(不含税):" v-if="goodform.pricingMethod==1">
               <span style="display:inline-block;width:200px">{{goodform.unitPrice}} 元/吨</span>
               <!-- <span style="display:inline-block;width:200px" v-else-if="goodform.pricingMethod==2">{{goodform.unitPrice}} 元</span> -->
              </el-form-item>
              <el-form-item label="包干价(不含税):"  v-if="goodform.pricingMethod==2">
               <span style="display:inline-block;width:200px">{{goodform.unitPrice}} 元</span>
              </el-form-item>
              <el-form-item label="杂费:">
                <span>{{goodform.incidental?goodform.incidental:0}} 元</span>
              </el-form-item>
             <!-- <el-form-item label="合计费用:" class="mar10" v-if="goodform.pricingMethod==1"  style="margin-left:170px">
                <span class="red">{{allP1|numFormat(2)}}</span>元
              </el-form-item>
              <el-form-item label=" 合计费用:" class="mar10" v-if="goodform.pricingMethod==2"  style="margin-left:100px">
               <span class="red">{{allP2|numFormat(2)}}</span>元
              </el-form-item> -->
            <!-- </div> -->
              <div>
              <el-form-item label="运费:" class="jiage" v-if="goodform.pricingMethod==1">
                <span style="display:inline-block;width:300px"><span class="red">{{expenses|numFormat(2)}}</span>元</span>
              </el-form-item>
              <el-form-item label="运费:" class="jiage" v-if="goodform.pricingMethod==2">
                <span style="display:inline-block;width:300px"><span class="red">{{goodform.unitPrice ? goodform.unitPrice : 0.00|numFormat(2)}}</span>元</span>
              </el-form-item>
              <!-- <el-form-item label="找车服务费:" label-width="211px"  class="jiage" >
                <span class="red">{{this.serviceFee|numFormat(2)}}</span>元
              </el-form-item> -->
              <el-form-item label="找车服务费:" class="jiage" >
                <span style="display:inline-block;width:192px"><span class="red">{{goodform.serviceFee|numFormat(2)}}</span>元</span>
              </el-form-item>
              <el-form-item label="合计费用:" class="mar10" v-if="goodform.pricingMethod==1">
                <span class="red">{{allP1|numFormat(2)}}</span>元
              </el-form-item>
              <el-form-item label="合计费用:" class="mar10" v-if="goodform.pricingMethod==2">
               <span class="red">{{allP2|numFormat(2)}}</span>元
              </el-form-item>
              <el-form-item label="" class="mar10">
                <span class="red">（注：合计费用=运费+找车服务费+杂费）</span>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="加价间隔时间:" prop="markupInterval" class="jiage">
                <span style="display:inline-block;width:300px" v-if="goodform.markupInterval">{{goodform.markupInterval}} 分钟</span>
                <span style="display:inline-block;width:300px" v-else>-</span>
              </el-form-item>
              <el-form-item label="加价间隔金额:" prop="markupAmount" class="jiage">
                <span style="display:inline-block;width:202px" v-if="goodform.markupAmount">{{goodform.markupAmount}} 元</span>
                <span style="display:inline-block;width:202px" v-else>-</span>
              </el-form-item>
              <el-form-item label="最高限价:" prop="markupHighAmount" class="jiage">
                <span v-if="goodform.markupHighAmount">{{goodform.markupHighAmount}} 元</span>
                <span v-else>-</span>
              </el-form-item>
            </div>
            <el-form-item  label="发布范围:" prop="publishScopeType" class="ziti" >
                  <span v-if="goodform.publishScopeType==1">长协承运商</span>
                  <span v-if="goodform.publishScopeType==2">指定承运商</span>
            </el-form-item>
            <div style="margin-left:110px;margin-bottom:20px" v-if="goodform.publishScopeType==2">
                <el-tag
                  v-for="(tag,index) in offerList"
                  :key="index">
                  {{tag}}
              </el-tag>
            </div>
            <div>
                <el-form-item label="抢单有效期至:" prop="demandFinalDate">
                  <el-date-picker
                    v-model="goodform.demandFinalDate"
                    format="yyyy-MM-dd HH:mm"
                    value-format="timestamp"
                    type="datetime"
                    :readonly="true"
                      placeholder=""
                  ></el-date-picker>
              </el-form-item>
        </div>

        <div v-if="goodform.triggerStatus == 2 || goodform.triggerStatus == 3">
            <el-form-item label="发布时间点:" prop="triggerStartDate">
                <!-- <el-time-picker
                  v-model="goodform.triggerStartDate"
                  format="HH"
                  value-format="timestamp"
                  :readonly="true"
                  placeholder=""
                ></el-time-picker> -->
               <span style="display:inline-block;width:300px">{{dateFormatUtil('hh:ii', goodform.triggerStartDate)}} </span>
            </el-form-item>
            <el-form-item label="抢单有效时长:" prop="triggerDuration" class="jiage">
               <span style="display:inline-block;width:202px">{{goodform.triggerDuration/60}} 小时</span>
            </el-form-item>
            <el-form-item label="循环结束日期:" prop="triggerEndDate" class="inpBox2">
                <el-date-picker
                  v-model="goodform.triggerEndDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                   :readonly="true"
                  placeholder=""
                ></el-date-picker>
            </el-form-item>
          </div>
        </div>
          </div>
        <hr>
      </div>
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>其他信息</span>
        </h4>
          <div>
              <el-form-item label="已购货险:" prop="isInsurance" class="ziti"  >
              <template >
                <el-radio-group v-model="goodform.isInsurance">
                  <el-radio :label="1" disabled >是</el-radio>
                  <el-radio :label="2" disabled>否</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
            <div style="display: inline-block;"  v-if="goodform.isInsurance==1">
              <el-form-item label="保险单号:" prop="insuranceNo" >
                <span style="display:inline-block;width:300px">{{goodform.insuranceNo}}</span>
              </el-form-item>
              <el-form-item label="保险公司名称:" prop="insuranceCompany" >
                <span>{{goodform.insuranceCompany}}</span>
              </el-form-item>
            </div>

          </div>
          <div>
             <el-form-item label="外部单号:" prop="outBillNo">
                <span style="display:inline-block;width:300px">{{goodform.outBillNo}}</span>
            </el-form-item>
            <el-form-item label="最晚提货时间:" prop="hopeReceivingDate">
                  <el-date-picker
                    v-model="goodform.hopeReceivingDate"
                    format="yyyy-MM-dd HH:mm"
                    value-format="timestamp"
                    type="datetime"
                    :readonly="true"
                      placeholder=""
                  ></el-date-picker>
            </el-form-item>
            <div>
              <el-form-item label="能源类型:" prop="energyName">
                <span style="display:inline-block;width:300px">{{goodform.energyName}}</span>
                <!-- <span style="display:inline-block;width:300px" v-if="goodform.energyName && JSON.parse(goodform.energyName).length != 0">
                  <span v-for="(item,index) in JSON.parse(goodform.energyName)" :key="index" >{{item}} {{index == JSON.parse(goodform.energyName).length-1 ? '':','}}</span>
                </span>
                <span  v-else style="display:inline-block;width:300px"></span> -->
              </el-form-item>
              <el-form-item label="排放标准:" prop="standardsName">
                <span style="display:inline-block;width:202px">{{goodform.standardsName}}</span>
                <!-- <span style="display:inline-block;width:202px" v-if="goodform.standardsName && JSON.parse(goodform.standardsName).length!= 0">
                  <span v-for="(item,index) in JSON.parse(goodform.standardsName)" :key="index" >{{item}} {{index == JSON.parse(goodform.standardsName).length-1 ? '':','}}</span>
                </span>
                <span v-else style="display:inline-block;width:202px"></span> -->
              </el-form-item>
              <el-form-item label="运输要求:" prop="transInfo">
                  {{goodform.transInfo}}
              </el-form-item>
            </div>
            <!-- <el-form-item label="备注信息:" class="remark" prop="remark" >
              <el-input  placeholder="" :readonly="true"   v-model="goodform.remark"></el-input>
            </el-form-item> -->
            <el-form-item label="备注信息:" class="remark" prop="remark" >
              <div class="remark1">{{goodform.remark}}</div>
            </el-form-item>
          </div>
      </div>
      <hr>
      <div class="addressBox" v-if="fileList.length>0">
        <h4 class="title">
          <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>货源图片</span>
        </h4>
          <div>
            <div class="imgBox">
              <ul >
                <li v-for="(item,index) in fileList" :key="index">
                  <el-image :src="item.fileUrlOSS"
                  style="width:100%; height: 100%"
                  :preview-src-list="getSrcList(index,fileList)">
                </el-image>
                </li>
              </ul>
            </div>
          </div>
           <hr>
      </div>
      <div class="addressBox" v-if="goodform.status != 1203">
        <h4 class="title">
          <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>作废信息</span>
        </h4>
           <!-- <div v-if="goodform.status == 1203">
            <el-form-item label="完成人:" prop="completeUserName">
                <span v-if="goodform.completeUserName" style="display:inline-block;width:300px">{{goodform.completeUserName}}</span>
                <span v-else style="display:inline-block;width:300px">-</span>
              </el-form-item>
            <el-form-item label="完成时间:" prop="completeTime">
              <el-date-picker v-model="goodform.completeTime"  v-if="goodform.completeTime" format="yyyy-MM-dd HH:mm:ss"  value-format="timestamp"
                type="datetime"
                :readonly="true"
                placeholder=""
                style="display:inline-block;width:202px"
              ></el-date-picker>
              <span v-else style="display:inline-block;width:202px">-</span>
            </el-form-item>
           </div> -->
            <!-- <div v-else> -->
            <el-form-item label="作废人:" prop="completeUserName">
                <span v-if="goodform.completeUserName" style="display:inline-block;width:300px">{{goodform.completeUserName}}</span>
                <span v-else style="display:inline-block;width:300px">-</span>
              </el-form-item>
            <el-form-item label="作废时间:" prop="completeTime">
              <el-date-picker v-model="goodform.completeTime"  v-if="goodform.completeTime" format="yyyy-MM-dd HH:mm:ss"  value-format="timestamp"
                type="datetime"
                :readonly="true"
                placeholder=""
                style="display:inline-block;width:202px"
              ></el-date-picker>
              <span v-else style="display:inline-block;width:202px">-</span>
            </el-form-item>
            <el-form-item label="作废原因:" prop="abandonReason" >
              <span v-if="goodform.abandonReason">{{goodform.abandonReason}}</span>
              <span v-else>-</span>
            </el-form-item>
           <!-- </div> -->
      </div>
   </el-form>
<!-- 预计费用明细 -->
    <el-dialog title="预计费用明细" :visible.sync="charge"  :close-on-click-modal="false" :close-on-press-escape="false"  width="800px" center>
       <div style="height:300px;margin-top:20px">
          <table border="1" cellpadding="0" cellspacing="0" class="table">
          <thead>
            <tr>
              <td>限价区间</td>
              <td>限价总价(元)</td>
              <td>找车服务费(含税/元)</td>
              <td>杂费(元)</td>
              <td>合计(元)</td>
            </tr>
          </thead>
          <tbody v-if="this.goodform.pricingMethod == 1">
            <tr>
              <td>最低限价</td>
              <td>{{lowTotalPrice}}</td>
              <td>{{goodform.serviceFee}}</td>
              <td>{{goodform.incidental}}</td>
              <td>{{Number(this.toFixed(addUp1,2))}}</td>
            </tr>
            <tr>
              <td>最高限价</td>
              <td>{{highTotalPrice}}</td>
              <td>{{goodform.serviceFee}}</td>
              <td>{{goodform.incidental}}</td>
              <td>{{Number(this.toFixed(addUp2,2))}}</td>
            </tr>
          </tbody>
          <tbody v-if="this.goodform.pricingMethod == 2">
            <tr>
              <td>最低限价</td>
              <td>{{goodform.lowPrice}}</td>
              <td>{{goodform.serviceFee}}</td>
              <td>{{goodform.incidental}}</td>
              <td>{{Number(this.toFixed(BGaddUp1,2))}}</td>
            </tr>
            <tr>
              <td>最高限价</td>
              <td>{{goodform.highPrice}}</td>
              <td>{{goodform.serviceFee}}</td>
              <td>{{goodform.incidental}}</td>
              <td>{{Number(this.toFixed(BGaddUp2,2))}}</td>
            </tr>
          </tbody>
        </table>
       </div>
       <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="charge = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { sDemandDetail } from '@/api/soc-stock'
import { toFixed, dateFormatUtil } from '@/utils/util'
export default {
  data () {
    let id = this.$route.query.id
    let status = this.$route.query.status
    return {
      dateFormatUtil: dateFormatUtil,
      id: id,
      status: status,
      toFixed: toFixed,
      goodform: { },
      goodList: [],
      offerList: [],
      charge: false,
      // serviceFee: 0,
      fileList: []
    }
  },
  created () {
    let formData = new FormData()
    formData.append('id', this.id)
    const loading = this.$loading({
      lock: true,
      text: '正在加载...'
    })
    sDemandDetail({ id: this.id }).then(res => {
      loading.close()
      this.goodform = res.demandList
      // this.serviceFee = this.goodform.serviceFee
      this.goodList = res.productList
      this.offerList = res.offerList
      this.fileList = res.fileList
    })
  },
  computed: {
    // 货物信息合计
    allWeight () {
      const options = this.goodList
      let weight = 0
      for (let index = 0; index < options.length; index++) {
        console.log(options)
        if (options[index].weight) {
          weight = parseFloat(options[index].weight) + parseFloat(weight)
        } else if (!options[index].weight && index != 0) {
          weight = weight + 0
        } else {
          weight = 0
        }
      }
      return weight
    },
    // 竞价
    addUp1 () {
      let total1 = 0
      if (this.goodform.lowPrice && this.allWeight) {
        total1 = parseFloat(total1) + Number(this.toFixed(parseFloat(this.goodform.lowPrice) * parseFloat(this.allWeight), 2)) + (this.goodform.incidental ? parseFloat(this.goodform.incidental) : 0) + parseFloat(this.goodform.serviceFee)
      }
      console.log(total1)
      return total1
    },
    addUp2 () {
      let total2 = 0
      if (this.goodform.highPrice && this.allWeight) {
        total2 = parseFloat(total2) + Number(this.toFixed(parseFloat(this.goodform.highPrice) * parseFloat(this.allWeight), 2)) + (this.goodform.incidental ? parseFloat(this.goodform.incidental) : 0) + parseFloat(this.goodform.serviceFee)
      }
      console.log(total2)
      return total2
    },
    BGaddUp1 () {
      let total1 = 0
      if (this.goodform.lowPrice) {
        total1 = parseFloat(total1) + parseFloat(this.goodform.lowPrice) + (this.goodform.incidental ? parseFloat(this.goodform.incidental) : 0) + parseFloat(this.goodform.serviceFee)
      }
      console.log(total1)
      return total1
    },
    BGaddUp2 () {
      let total2 = 0
      if (this.goodform.highPrice) {
        total2 = parseFloat(total2) + parseFloat(this.goodform.highPrice) + (this.goodform.incidental ? parseFloat(this.goodform.incidental) : 0) + parseFloat(this.goodform.serviceFee)
      }
      console.log(total2)
      return total2
    },
    lowTotalPrice () {
      let lowTotal = 0
      if (this.goodform.lowPrice && this.allWeight) {
        lowTotal = parseFloat(lowTotal) + Number(this.toFixed(parseFloat(this.goodform.lowPrice) * parseFloat(this.allWeight), 2))
      }
      console.log(lowTotal)
      return lowTotal
    },
    highTotalPrice () {
      let highTotal = 0
      if (this.goodform.highPrice && this.allWeight) {
        highTotal = parseFloat(highTotal) + Number(this.toFixed(parseFloat(this.goodform.highPrice) * parseFloat(this.allWeight), 2))
      }
      console.log(highTotal)
      return highTotal
    },
    // 抢单
    expenses () {
      let lowTotal = 0
      if (this.goodform.unitPrice && this.allWeight) {
        lowTotal = parseFloat(lowTotal) + Number(this.toFixed(parseFloat(this.goodform.unitPrice) * parseFloat(this.allWeight), 2))
      }
      console.log(lowTotal)
      return lowTotal
    },
    allP1 () {
      let total1 = 0
      if (this.goodform.unitPrice && this.allWeight) {
        total1 = parseFloat(total1) + Number(this.toFixed(parseFloat(this.goodform.unitPrice) * parseFloat(this.allWeight), 2)) + (this.goodform.incidental ? parseFloat(this.goodform.incidental) : 0) + parseFloat(this.goodform.serviceFee)
      }
      console.log(total1)
      return total1
    },
    allP2 () {
      let total1 = 0
      if (this.goodform.unitPrice) {
        total1 = parseFloat(total1) + parseFloat(this.goodform.unitPrice) + (this.goodform.incidental ? parseFloat(this.goodform.incidental) : 0) + parseFloat(this.goodform.serviceFee)
      }
      console.log(total1)
      return total1
    }
  },
  methods: {
    totalFN () {
      this.charge = true
    },
    // 点击凭证放大
    // getSrcList (index, arr) {
    //   return arr.slice(index).concat(arr.slice(0, index))
    // },
    // 点击凭证放大
    getSrcList (index, arr) {
      let list = []
      arr.forEach(item => {
        list.push(item.fileUrlOSS)
      })
      return list.slice(index).concat(list.slice(0, index))
    },
    back () {
      this.$router.go(-1)// 返回上一层
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
    t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = ''
      } else {
        str = t.getFullYear() + '-' + month + '-' + date + ' ' + hour + ':' + minutes + ':' + seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style scoped lang='less'>

.imgBox{
  margin: 22px 35px;
  ul{
    display: flex;
    padding-left: 0;
    li{
         width: 160px;
    height: 160px;
    list-style: none;
    margin-right: 10px;
      img{
        width:100%;
        height:100%
      }
    }
  }
}
.inpBox  /deep/.el-input__inner{
  border:none;
  padding: 0;
  color:#333;
   font-size: 14px;
}
.hidden /deep/.el-upload--picture-card{
  display: none;
}
/deep/.el-form-item--mini.el-form-item{
    margin-bottom: 0px;
}
/deep/.el-input.is-disabled .el-input__inner{
  background: #fff;
}
 /deep/.el-input__suffix, /deep/.el-input__icon{
   display: none;
 }
 .danwei{
   /deep/ .el-input__inner{
         width: 300px;
    overflow: auto;
   }
 }
.box1{
  display: flex;
  padding-left: 20px;
  .item{
    max-width: 48%;
    margin-left: 16px;
    font-size: 14px;
  }
  .item1{
    max-width: 48%;
    margin-left: 70px;
    font-size: 14px;
  }
  .box1T{
    margin-bottom: 10px;
    font-weight: bold;
  }
  .box1B{
    display: flex;
    flex-wrap: wrap;
    span{
      margin-right: 20px;
      line-height: 26px;
    }
  }
}
/deep/.el-tag{
  margin-right: 10px;
}
table{
width: 100%;
height: 25%;
  td{
    padding: 8px 10px;
    text-align: center;
  }
}
.footer{
   margin-top: 20px;
}
.remark1 {
  display: flex;
  flex-wrap: wrap;
  width: 650px;
}
</style>
